import React from 'react'
import StyledXlText from '../../common/components/styledXlText/StyledXlText'
import StyledSmText from '../../common/components/styledSmText/StyledSmText'

const HubCard = ({ data }) => {
    return (
        <div className='flex flex-col items-center gap-3 lg:items-start'>
            <div>
                <img width={175} height={175} src={data?.imgUrl} alt='Img#1' />
            </div>
            <div>
                <StyledXlText fontColor="text-white">{data?.heading}</StyledXlText>
            </div>
            <div className="text-center lg:text-left">
                <StyledSmText fontColor="text-white">{data?.desc}</StyledSmText>
            </div>
        </div>
    )
}

export default HubCard
